// ─────────────────────────────────────────────────────────────────────────────
// UsersToolbar.js — search field + "Filters" toggle + total count, and the
// expandable filter panel (status / role / team chips). Filter state is owned
// by useUserFilters and passed down; only the panel's open/closed is local.
// ─────────────────────────────────────────────────────────────────────────────
import { useState } from "react";
import styles from "./UsersToolbar.module.css";
import { Icons } from "../../../components/Icons";
import { STATUS_CONFIG } from "./badges";

const ROLES    = ["All", "Admin", "Security Admin", "IT Manager", "Auditor", "User"];
const STATUSES = ["All", "active", "offline", "blocked"];

export default function UsersToolbar({
  search, onSearch,
  filterStatus, onFilterStatus,
  filterRole, onFilterRole,
  filterTeam, onFilterTeam,
  teams, hasFilters, total,
}) {
  const [showFilters, setShowFilters] = useState(false);

  return (
    <>
      <div className={styles.toolbar}>
        <div className={styles.searchBox}>
          <span className={styles.searchIcon}>{Icons.search}</span>
          <input
            className={styles.searchInput}
            placeholder="Search by name or email…"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
        <button
          className={`${styles.filterToggleBtn} ${showFilters ? styles.filterToggleActive : ""}`}
          onClick={() => setShowFilters((f) => !f)}
        >
          {Icons.filter}
          Filters
          {hasFilters && <span className={styles.filterBadge} />}
        </button>
        <div className={styles.totalUsers}>
          Total Users: <strong>{total}</strong>
        </div>
      </div>

      {showFilters && (
        <div className={styles.filterPanel}>
          <div className={styles.filterGroup}>
            <span className={styles.filterGroupLabel}>Status</span>
            <div className={styles.filterChips}>
              {STATUSES.map((s) => {
                const cfg = STATUS_CONFIG[s];
                const active = filterStatus === s;
                return (
                  <button key={s}
                    className={`${styles.chip} ${active ? styles.chipActive : ""}`}
                    style={active && cfg ? { color: cfg.color, borderColor: cfg.color, background: cfg.bg } : undefined}
                    onClick={() => onFilterStatus(s)}
                  >
                    {cfg && <span className={styles.chipDot} style={{ background: cfg.color }} />}
                    {cfg ? cfg.label : "All"}
                  </button>
                );
              })}
            </div>
          </div>
          <div className={styles.filterGroup}>
            <span className={styles.filterGroupLabel}>Role</span>
            <div className={styles.filterChips}>
              {ROLES.map((r) => (
                <button key={r}
                  className={`${styles.chip} ${filterRole === r ? styles.chipActive : ""}`}
                  onClick={() => onFilterRole(r)}
                >{r}</button>
              ))}
            </div>
          </div>
          {teams.length > 1 && (
            <div className={styles.filterGroup}>
              <span className={styles.filterGroupLabel}>Team</span>
              <div className={styles.filterChips}>
                {teams.map((t) => (
                  <button key={t}
                    className={`${styles.chip} ${filterTeam === t ? styles.chipActive : ""}`}
                    onClick={() => onFilterTeam(t)}
                  >{t}</button>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
